"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QlubProvider = exports.Decorator = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const theme_1 = require("../theme");
const react_1 = require("react");
const Decorator = (storyFn) => {
    const windowResizeHandler = () => {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
    (0, react_1.useEffect)(() => {
        windowResizeHandler();
        window.addEventListener('resize', windowResizeHandler);
        return () => {
            window.addEventListener('resize', windowResizeHandler);
        };
    }, []);
    return (0, jsx_runtime_1.jsx)(material_1.ThemeProvider, { theme: theme_1.theme, children: storyFn() });
};
exports.Decorator = Decorator;
const QlubProvider = (props) => (0, jsx_runtime_1.jsx)(material_1.ThemeProvider, { theme: theme_1.theme, children: props.children });
exports.QlubProvider = QlubProvider;
